export default "__VITE_ASSET__DlKqwcOF__"